export const logoutHandler = () => {
    const domain = `${window.location.protocol}//${window.location.host}`;
    const redirectUrl = `${domain}/api/v1/logout?redirectUrl=${domain}/`;
    window.location.replace(redirectUrl);
  };